// src/utils/QRCodeGenerator.js
// Simple QR Code generator utility for ID cards

export const generateQRCodeSVG = (data, size = 120) => {
  // This is a simplified QR code generator
  // In production, you should use a proper QR code library like 'qrcode' or 'qrcode-generator'
  
  const moduleCount = 21; // Standard QR code size
  const moduleSize = size / moduleCount;
  
  // Create a simple pattern based on the data
  const modules = [];
  for (let i = 0; i < moduleCount; i++) {
    modules[i] = [];
    for (let j = 0; j < moduleCount; j++) {
      // Create a pseudo-random pattern based on data and position
      const hash = simpleHash(data + i + j);
      modules[i][j] = hash % 2 === 0;
    }
  }
  
  // Add finder patterns (corner squares)
  addFinderPattern(modules, 0, 0);
  addFinderPattern(modules, moduleCount - 7, 0);
  addFinderPattern(modules, 0, moduleCount - 7);
  
  // Generate SVG
  let svg = `<svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" xmlns="http://www.w3.org/2000/svg">`;
  svg += `<rect width="${size}" height="${size}" fill="white"/>`;
  
  for (let i = 0; i < moduleCount; i++) {
    for (let j = 0; j < moduleCount; j++) {
      if (modules[i][j]) {
        const x = j * moduleSize;
        const y = i * moduleSize;
        svg += `<rect x="${x}" y="${y}" width="${moduleSize}" height="${moduleSize}" fill="black"/>`;
      }
    }
  }
  
  svg += '</svg>';
  return svg;
};

// Simple hash function
const simpleHash = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
};

// Add finder pattern (7x7 square in corners)
const addFinderPattern = (modules, startX, startY) => {
  const pattern = [
    [1,1,1,1,1,1,1],
    [1,0,0,0,0,0,1],
    [1,0,1,1,1,0,1],
    [1,0,1,1,1,0,1],
    [1,0,1,1,1,0,1],
    [1,0,0,0,0,0,1],
    [1,1,1,1,1,1,1]
  ];
  
  for (let i = 0; i < 7; i++) {
    for (let j = 0; j < 7; j++) {
      if (startX + i < modules.length && startY + j < modules[0].length) {
        modules[startX + i][startY + j] = pattern[i][j] === 1;
      }
    }
  }
};

// Generate vCard data
export const generateVCard = (userData) => {
  const nameParts = userData.name.split(' ');
  const lastName = nameParts.length > 1 ? nameParts.pop() : '';
  const firstName = nameParts.join(' ');

  let vcard = 'BEGIN:VCARD\nVERSION:3.0\n';
  vcard += `FN:${userData.name}\n`;
  vcard += `N:${lastName};${firstName};;;\n`;
  vcard += `TITLE:${userData.title}\n`;
  vcard += `ORG:${userData.company}\n`;
  vcard += `EMAIL;type=WORK:${userData.email}\n`;
  vcard += `TEL;type=CELL:${userData.phone}\n`;
  vcard += `ADR;type=WORK:;;${userData.location}\n`;
  vcard += `NOTE:Employee ID: ${userData.employeeId}\n`;
  vcard += 'END:VCARD';
  return vcard;
};

export default { generateQRCodeSVG, generateVCard };